import React, { Component, Fragment } from "react";
import ReactHtmlParser from "react-html-parser";
import "./recentMinutes.css";
import download from 'downloadjs';
import mime from 'mime-types';
import { host, frontendUrl } from "../../utils/globals";

export default class Details extends Component {
    onDownload = (url, name) => {
        let mimetype = mime.lookup(name);
        let x = new XMLHttpRequest();
        x.open("GET", url, true);
        x.responseType = 'blob';
        x.onload = function (e) {
            download(x.response, name, mimetype);
        }
        x.send();
    }

    render() {
        const { data } = this.props;
        return (
            <Fragment>
                <div className="col-xs-12">
                    <div className="row top-data">
                        <div className="col-sx-12 col-md-6 venum">
                            <div className="venum">
                                <i className="fa fa-map-marker" aria-hidden="true" /> Venue :{" "}
                                {data && data.venue}
                            </div>
                            <div>
                                <i className="fa fa-clock-o" /> Time
                                : {data && data.time}
                            </div>
                        </div>
                        <div className="col-sx-12 col-md-6 venum">
                            <div className="venum">
                                <i className="fa fa-calendar" /> Start :{" "}
                                {data && data.start_date}
                            </div>
                            <div>
                                <i className="fa fa-calendar" /> End : {data && data.end_date}
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div>{ReactHtmlParser(data && data.details)}</div>
                </div>
                <div
                    className="meetingDov"
                    style={{ marginTop: "20px", marginLeft: "15px" }}
                >
                    <div className="inner-title change-title">
                        <h1 style={{ marginTop: "20px" }}>Meeting Documents List</h1>
                        <div id="meeting-list">
                            <ul className="list-unstyled">
                                {data &&
                                    data.documents &&
                                    data.documents.map((d, i) => (
                                        <li>
                                            <figure>
                                                <img src="/img/pdf.svg" alt="" />
                                            </figure>
                                            <div>
                                                <p>
                                                    <a className="active" aria-current="true" target="_blank" href={frontendUrl + d.file_path}>
                                                        {d.doc_name}
                                                    </a>
                                                </p>
                                            </div>
                                            <div style={{ marginTop: "10px" }}>
                                                <small className="color-date pull-left">
                                                    {d.file_size}
                                                </small>
                                                <small className="download pull-right"
                                                    onClick={() => this.onDownload(d.file_path, `${d.doc_name}.pdf`)}>
                                                    <i className="fa fa-download" />
                                                    Download
                                            </small>
                                            </div>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
